import { render, staticRenderFns } from "./AttributesLandingPage.vue?vue&type=template&id=4b8decf3&scoped=true"
import script from "./AttributesLandingPage.vue?vue&type=script&lang=js"
export * from "./AttributesLandingPage.vue?vue&type=script&lang=js"
import style0 from "./AttributesLandingPage.vue?vue&type=style&index=0&id=4b8decf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8decf3",
  null
  
)

export default component.exports